import PropTypes from 'prop-types';
import { PackagePropType } from './package';

export const RateBrowserDefaultsPropType = PropTypes.shape({
  shipFromId: PropTypes.string,
  shipToCountryCode: PropTypes.string,
  selectedPackage: PackagePropType,
});

/**
 * @typedef {object} RateBrowserDefaultsPropType
 * @property {string} shipFromId
 * @property {string} shipToCountryCode
 * @property {string} selectedPackage
 */
